import { LaserficheMultiConnectionEditor } from "@/components/integrations/LaserficheMultiConnectionEditor";
import { LaserfichePushHistoryEditor } from "@/components/integrations/LaserfichePushHistoryEditor";
import { PageHeader } from "@/components/page";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const IntegrationLaserficheMultiConnectionsPage = () => {
  const { tenantId } = useParams();

  // navigate to "push" section
  useEffect(() => {
    const hash = location.hash;

    if (hash.toLowerCase() === "#push") {
      document.querySelector(hash)?.scrollIntoView();
    }
  }, []);

  return (
    <div className="flex flex-col flex-grow gap-5">
      {tenantId ? (
        <>
          <PageHeader title="Manage All Laserfiche Connections" />
          <LaserficheMultiConnectionEditor tenantId={tenantId} />

          <div className="h-5" />

          <PageHeader title="Push Historic Data to Laserfiche" id="push" />
          <LaserfichePushHistoryEditor tenantId={tenantId} />

          <div className="h-20" />
        </>
      ) : (
        <p>No tenant loaded</p>
      )}
    </div>
  );
};
